import Snackbar from '@mui/material/Snackbar';
import type { Notification } from '@witmetrics/utils';
import SlideTransition from '@/components/SlideTransition';
import { NotificationsListItem } from '@/components/NotificationsList';
import { classes, styles } from './utils';

export type NotificationToasterProps = {
  notification: Notification;
  onClose: () => void;
};

export default function NotificationToaster({
  notification,
  onClose,
}: NotificationToasterProps) {
  return (
    <Snackbar
      open
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      ClickAwayListenerProps={{ mouseEvent: false }}
      TransitionComponent={SlideTransition}
      onClose={onClose}>
      <div style={styles.wrapper} className={classes.wrapper}>
        <NotificationsListItem
          className={classes.listItem}
          notification={notification}
          onOpen={onClose}
          onDelete={onClose}
        />
      </div>
    </Snackbar>
  );
}
